function youtubeVideoWidthDefine() {
    var videoWidth = $('.item-which-define-width-of-the-video').width();
    return videoWidth;
}

$(document).ready(function () {
    var youtubeVideo = $('.item-which-define-width-of-the-video').find(
        'iframe'
    );
    youtubeVideo.each(function () {
        $(this)
            .attr('data-aspectRatio', this.height / this.width)
            .removeAttr('height')
            .removeAttr('width');
    });

    youtubeVideoWidthDefine();

    $(window)
        .on('resize orientationchange', function () {
            if (
                $('.item-which-define-width-of-the-video').find('iframe').length
            ) {
                var videoWidth = youtubeVideoWidthDefine();
                var newWidth = videoWidth;
                youtubeVideo.each(function () {
                    var newHeight = newWidth * $(this).attr('data-aspectRatio');
                    $(this).width(newWidth).height(newHeight);
                });
            }
        })
        .resize();
});
